<!-- ============================================================
  BookedByCell — คอลัมน์ "จองโดย" ของตารางประวัติการใช้คอร์ส (ใช้ร่วม 3 จอ:
  คอร์สลูกค้า / ประวัติคอร์ส / นักเรียน) · ข้อมูลจาก /getStudentCourseDetail → courseDetail
  (createby, createby_role, createdate ของใบจอง — ไม่ใช่ updateby ของคอร์ส)
============================================================ -->
<template>
  <div class="bbc">
    <span>{{ name || '-' }}</span>
    <span v-if="roleKey" class="badge badge-neutral bbc-role">{{ $t(roleKey) }}</span>
    <div v-if="at" class="t-cap">{{ $formatDateTime(at) }}</div>
  </div>
</template>

<script>
export const ROLE_LABELS = { 0: 'editHistory.roleHead', 1: 'editHistory.roleAdmin', 2: 'editHistory.roleCoach', 10: 'editHistory.roleCustomer' };

export default {
  name: 'BookedByCell',
  props: {
    name: { type: String, default: '' },
    role: { type: [String, Number], default: null },
    at: { type: [String, Date], default: null },
  },
  computed: {
    roleKey() { return this.role === null || this.role === undefined ? null : ROLE_LABELS[this.role] || null; },
  },
};
</script>

<style scoped>
.bbc { padding: 4px 0; line-height: 1.35; }
.bbc-role { height: 18px; padding: 0 7px; font-size: 11px; margin-left: 4px; }
</style>
